import { IDashboardCard } from './../../interfaces/models/performance..model';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DropdownModule } from 'primeng/dropdown';
import { StrategyService } from '../../services/strategy.service';
import { Strategy } from '../../interfaces/models/strategy.model';
import { PerformanceCardComponent } from '../../shared/performance-card/performance-card.component';
import { DashboardService } from '../../services/dashboard.service';
import { ProjectService } from '../../services/project.service';
import { count, filter, switchMap } from 'rxjs';
import { Goal } from '../../interfaces/models/goal.model';
import { Indicator } from '../../interfaces/models/indicator.model';
import { IProject } from '../../interfaces/models/project.model';
import { DashboardCards, PerformanceCardsNamesEnum, ProjectCardsNamesEnum } from '../../interfaces/models/performance..model';
import { CommonModule } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { ProjectCardComponent } from '../../shared/project-card/project-card.component';
import { ChartComponent, NgApexchartsModule } from 'ng-apexcharts';
import { TableModule } from 'primeng/table';
import { MessagesModule } from 'primeng/messages';
import { SubstringPipe } from "../../pipes/substring.pipe";
import { TooltipModule } from 'primeng/tooltip';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { SocketService } from '../../services/socket.service';
import { TranslateModule } from '@ngx-translate/core';
import { DirectionService } from '../../services/direction.service';
import { GoalsComponent } from '../../shared/components/goals/goals.component';
import { SharedProjectComponent } from '../../shared/components/shared-project/shared-project.component';
import { SharedIndicatorComponent } from '../../shared/components/shared-indicator/shared-indicator.component';
import { InputTextModule } from 'primeng/inputtext';
import { trigger, state, style, transition, animate } from '@angular/animations';

import { NavTitlePipe } from '../../pipes/nav-title.pipe';

@Component({
  selector: 'app-performance',
  standalone: true,
  templateUrl: './performance.component.html',
  styleUrl: './performance.component.scss',
  animations: [
    trigger('slideDown', [
      transition(':enter', [
        style({ height: 0, opacity: 0, overflow: 'hidden' }),
        animate('300ms ease-out', style({ height: '*', opacity: 1 }))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, overflow: 'hidden' }),
        animate('300ms ease-in', style({ height: 0, opacity: 0 }))
      ])
    ])
  ],
  imports: [
    NavTitlePipe,
    DropdownModule,
    ProjectCardComponent,
    TagModule,
    DialogModule,
    FormsModule,
    CommonModule,
    RouterModule,
    PerformanceCardComponent,
    NgApexchartsModule,
    TableModule,
    MessagesModule,
    SubstringPipe,
    TooltipModule,
    OverlayPanelModule,
    TranslateModule,
    TagModule,
    SubstringPipe,
    GoalsComponent,
    SharedProjectComponent,
    SharedIndicatorComponent,
    InputTextModule
  ]
})
export class PerformanceComponent implements OnInit {
  modalHeaderName = ""
  @ViewChild("chart") chart!: ChartComponent;
  chartOptions = {
    series: [75],
    chart: {
      height: 350,
      type: "radialBar",
      toolbar: {
        show: true
      }
    },
    plotOptions: {
      radialBar: {
        startAngle: -135,
        endAngle: 225,
        hollow: {
          margin: 0,
          size: "70%",
          background: "#fff",
          image: undefined,
          position: "front",
          dropShadow: {
            enabled: true,
            top: 3,
            left: 0,
            blur: 4,
            opacity: 0.24
          }
        },
        track: {
          background: "#fff",
          strokeWidth: "67%",
          margin: 0, // margin is in pixels
          dropShadow: {
            enabled: true,
            top: -3,
            left: 0,
            blur: 4,
            opacity: 0.35
          }
        },

        dataLabels: {
          show: true,
          name: {
            offsetY: -10,
            show: true,
            color: "#888",
            fontSize: "17px"
          },
          value: {
            formatter: function (val: any) {
              return parseInt(val.toString(), 10).toString();
            },
            color: "#111",
            fontSize: "36px",
            show: true
          }
        }
      }
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: "dark",
        type: "horizontal",
        shadeIntensity: 0.5,
        gradientToColors: ["#ABE5A1"],
        inverseColors: true,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100]
      }
    },
    stroke: {
      lineCap: "round"
    },
    labels: ["Percent"]
  } as any




  hoverIndicatorId = 0;
  hoveredProjectId = 0;
  visible = false;
  selectedModalType = ''
  selectedStrategy = {} as Strategy
  departments: any;
  sections: any;
  filteredSections: any;
  selectedSection!: any;
  projects = [] as IProject[];
  filteredProjects: any;
  years = [] as {}[];
  selectedYear: { id: string | number, name: string } = {
    id: 'all',
    name: ""
  }
  onGoingProjects = [] as IProject[];
  lateProjects = [] as IProject[];
  finishedProjects = [] as IProject[];
  goals = [] as Goal[]
  indicators = [] as Indicator[]
  filtersVisible: boolean = false;
  selectedDepartment: any;
  selectedStrategyId = 0;
  selectedSectionId = 0;
  selectedProjectId = 0;
  selectedProjectName = ''
  isProjectVisable = false;
  selectedProjectModalType = ''
  performnceCards = DashboardCards.slice(0, 6).map((card) => ({
    id: card.id,
    icon: card.icon,
    name: card.arName,
    count: 0
  })) as IDashboardCard[];

  private lastPerformanceResponse: any = null;

  selectedProject = {} as any;
  dir!: 'rtl' | 'ltr';
  projectCards = [
    {
      id: ProjectCardsNamesEnum.resources,
      name: "Estimated budget for Execution",
      icon: "fa-solid fa-bullseye f-right",
      count: 0
    },
    {
      id: ProjectCardsNamesEnum.milestones,
      name: "Milestones",
      icon: "fa-solid fa-list-check",
      count: 0
    },
    {
      id: ProjectCardsNamesEnum.risks,
      name: "Risks",
      icon: "fa-solid fa-triangle-exclamation f-right",
      count: 0
    }

  ] as {
    id: ProjectCardsNamesEnum,
    name: string,
    count: number,
    icon: string
  }[];
  projectCardLocales = [
    {
      id: ProjectCardsNamesEnum.resources,
      enName: "Estimated budget for Execution",
      arName: "الميزانية التقديرية للتنفيذ",
    },
    {
      id: ProjectCardsNamesEnum.milestones,
      enName: "Milestones",
      arName: "مراحل التنفيذ",
    },
    {
      id: ProjectCardsNamesEnum.risks,
      enName: "Risks",
      arName: "المخاطر",
    }
  ] as {
    id: ProjectCardsNamesEnum,
    arName: string,
    enName: string,
  }[];


  headerEntityTitelType = ""
  projectStatistics: any = null;
  
  // Comparison Charts
  strategicAlignmentChart: any = {};
  projectsComparisonChart: any = {};
  projectsStatusChart: any = {};
  
  constructor(
    private strategyService: StrategyService,
    private dashboardService: DashboardService,
    private socketService: SocketService,
    private directionService: DirectionService,
    private projectService: ProjectService

  ) {
  }
  ngOnInit(): void {
    this.directionService.direction$.subscribe((dir) => {
      this.dir = dir;
      console.log(" this.dir", this.dir);
      this.setLocale();
      this.setYears(this.years as [])
      this.setDepartments(this.departments as [])
    })

    this.strategyService.RawStrategies$.subscribe((strategies: Strategy[]) => {
      this.strategyOptions = strategies.map((x) => ({ name: x.name, strategyId: x.id }))
    })

    this.strategyService.defaultStrategy$.pipe(switchMap((defaultStrategy: any) => {
      this.selectedStrategyId = defaultStrategy?.id as number
      this.selectedStrategy = defaultStrategy as Strategy
      
      // Get project statistics separately
      this.projectService.getProjectStatistics(defaultStrategy?.id as number).subscribe((stats: any) => {
        this.projectStatistics = stats.data?.statistics ?? stats.data;
        if (this.lastPerformanceResponse) {
          this.mapUnitPerfomanceCards(this.lastPerformanceResponse);
        }
      });
      
      return this.dashboardService.getPerformanceOverview(defaultStrategy?.id as number, this.selectedYear.id)
    })).subscribe((response: any) => {
      this.setYears(response["data"]["years"]);
      this.setDepartments(response["data"]["departments"]);
      console.log("departents", this.departments);
      this.selectedYear = this.years.find((year: any) => year.id == 'all') as any;
      this.selectedDepartment = this.departments.find((year: any) => year.id == 'all') as any;
      this.sections = response['data']['units']
      this.filteredSections = response['data']['units']
      this.mapUnitPerfomanceCards(response)
    })


    this.strategyService.strategyIdSub$.pipe(
      filter((x) => x > 0),
      switchMap((strategyId) => {
        // Get project statistics for the new strategy
        this.projectService.getProjectStatistics(strategyId).subscribe((stats: any) => {
          this.projectStatistics = stats.data?.statistics ?? stats.data;
          if (this.lastPerformanceResponse) {
            this.mapUnitPerfomanceCards(this.lastPerformanceResponse);
          }
        });
        
        return this.dashboardService.getPerformanceOverview(strategyId || 0, this.selectedYear.id);
      })
    ).subscribe((response: any) => {
      this.setYears(response["data"]["years"]);
      this.setDepartments(response["data"]["departments"])
      console.log(this.departments);
      this.selectedYear.id = 'all';
      this.sections = response['data']['units']
      this.filteredSections = response['data']['units']
      this.mapUnitPerfomanceCards(response)
    })


    this.dashboardService.departments$.subscribe((response) => {
      this.mapUnitPerfomanceCards(response)
    })

    this.dashboardService.sections$.subscribe((response) => {
      this.mapUnitPerfomanceCards(response)
    })
    this.dashboardService.projects$.subscribe((response: any) => {

      const { milestones, risks, teamMembers, resource } = response["data"]
      const localeKey = this.dir == 'ltr' ? "enName" : "arName";
      this.projectCards = [
        {
          id: ProjectCardsNamesEnum.resources,
          name: this.projectCardLocales[0][localeKey],
          icon: "fa-solid fa-coins",
          count: resource.estimated_budget
        },
        {
          id: ProjectCardsNamesEnum.milestones,
          name: this.projectCardLocales[1][localeKey],
          icon: "fa-solid fa-list-check",
          count: milestones.length
        },
        {
          id: ProjectCardsNamesEnum.risks,
          name: this.projectCardLocales[2][localeKey],
          icon: "fa-solid fa-triangle-exclamation f-right",
          count: risks.length
        }

      ]

      console.log("this.projectCards", this.projectCards);

      this.selectedProject = { ...{ milestones, risks, teamMembers, resource } }

      const { progress_percentage, progress_color } = response["data"]

      this.chartOptions = {
        series: [progress_percentage],
        chart: {
          height: 350,
          type: "radialBar"
        },
        fill: {
          colors: [progress_color],
          type: "solid",
          // gradient: {
          //   shade: "dark",
          //   type: "vertical",
          //   gradientToColors: ["#87D4F9"],
          //   stops: [0, 100]
          // }
        },
        stroke: {
          lineCap: "round"
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: "70%",
              background: "#293450"
            },
            track: {
              dropShadow: {
                enabled: true,
                top: 2,
                left: 0,
                blur: 4,
                opacity: 0.15
              }
            },
            dataLabels: {
              name: {
                offsetY: -10,
                color: "#fff",
                fontSize: "13px",
                fontFamily: "Cairo"
              },
              value: {
                color: "#fff",
                fontSize: "30px",
                fontFamily: "Cairo",
                show: true
              }
            }
          }
        },
        labels: [this.dir == 'ltr' ? "Progress Percentage" : "نسبة الإنجاز"]
      };
    })


  };
  strategyOptions = [] as { name: string, strategyId: number }[];
  departmentChange() {
    if (this.selectedDepartment.id == 'all') {
      // Reload statistics for overall view
      this.projectService.getProjectStatistics(this.selectedStrategyId).subscribe((stats: any) => {
        this.projectStatistics = stats.data?.statistics ?? stats.data;
        if (this.lastPerformanceResponse) {
          this.mapUnitPerfomanceCards(this.lastPerformanceResponse);
        }
      });
      
      this.dashboardService.getPerformanceOverview(this.selectedStrategyId as number, this.selectedYear.id)
        .subscribe((response: any) => {
          this.setYears(response["data"]["years"]);
          this.setDepartments(response["data"]["departments"])
          console.log(this.departments);
          this.sections = response['data']['units']
          this.filteredSections = response['data']['units']
          this.mapUnitPerfomanceCards(response)
          this.selectedProjectId = 0;
          this.selectedSectionId = 0;
        })
      return;
    }
    
    // Clear statistics when filtering by department (use filtered data instead)
    this.projectStatistics = null;
    this.filteredSections = this.selectedDepartment.units;
    this.dashboardService.
      setDepartmentSub({
        strategyId: this.selectedStrategyId,
        departmentId: this.selectedDepartment.id,
        year: this.selectedYear.id
      })
    this.headerEntityTitelType = "department";
    this.selectedProjectId = 0;
    this.selectedSection = 0;
  }
  sectionChange() {
    // Clear statistics when filtering by section (use filtered data instead)
    this.projectStatistics = null;
    
    this.dashboardService.seSectionSub({
      strategyId: this.selectedStrategyId,
      sectionId: this.selectedSectionId,
      year: this.selectedYear.id
    })
    this.headerEntityTitelType = "section";
    this.selectedSection = this.filteredSections.find((x: any) => x.id == this.selectedSectionId)
    this.selectedProjectId = 0;
    // this.selectedDepartment = 'all';
  }
  projectChange() {
    this.headerEntityTitelType = "project";
    const selectedProject = this.filteredProjects.find((x: any) => x.id == this.selectedProjectId);

    console.log("selectedProject", selectedProject);
    this.selectedProjectName = selectedProject.name;
    this.dashboardService.setProjectSub({
      strategyId: this.selectedStrategyId,
      projectId: this.selectedProjectId,
      year: this.selectedYear.id
    })
  }
  mapUnitPerfomanceCards(response: any) {
    this.lastPerformanceResponse = response;
    const unitPerformance = response["data"] as {
      "projects": [],
      "goals": [],
      "indicators": [],
      "finishedProjects": [],
      "onGoingProjects": [],
      "lateProjects": [],
      "entity": {
        "id": number,
        "department_id": number,
        "name": string
      }
    };

    this.goals = unitPerformance['goals']
    this.indicators = unitPerformance['indicators']

    this.filteredProjects = unitPerformance['projects']
    this.projects = unitPerformance['projects'];
    console.log("unitPerformance['projects']", unitPerformance['projects']);
    console.log(" this.filteredProjects ", this.filteredProjects);
    this.finishedProjects = unitPerformance['finishedProjects']
    this.onGoingProjects = unitPerformance['onGoingProjects']
    this.lateProjects = unitPerformance['lateProjects'];

    const localeKey = this.dir == 'ltr' ? "enName" : "arName";
    const byStatus = this.projectStatistics?.by_assessment_status ?? {};

    const goalsCount = unitPerformance.goals?.length ?? 0;
    const indicatorsCount = unitPerformance.indicators?.length ?? 0;
    const projectsCount = this.projectStatistics?.total ?? unitPerformance.projects?.length ?? 0;
    const approvedCount = byStatus['approved'] ?? 0;
    const pendingCount = byStatus['pending'] ?? 0;
    const rejectedCount = byStatus['rejected'] ?? 0;
    
    this.performnceCards = [
      {
        id: PerformanceCardsNamesEnum.goals,
        name: DashboardCards[0][localeKey],
        icon: DashboardCards[0].icon,
        count: goalsCount
      },
      {
        id: PerformanceCardsNamesEnum.indicators,
        name: DashboardCards[1][localeKey],
        icon: DashboardCards[1].icon,
        count: indicatorsCount
      },
      {
        id: PerformanceCardsNamesEnum.projects,
        name: DashboardCards[2][localeKey],
        icon: DashboardCards[2].icon,
        count: projectsCount
      },
      {
        id: PerformanceCardsNamesEnum.approvedProjects,
        name: DashboardCards[3][localeKey],
        icon: DashboardCards[3].icon,
        count: approvedCount
      },
      {
        id: PerformanceCardsNamesEnum.pendingProjects,
        name: DashboardCards[4][localeKey],
        icon: DashboardCards[4].icon,
        count: pendingCount
      },
      {
        id: PerformanceCardsNamesEnum.rejectedProjects,
        name: DashboardCards[5][localeKey],
        icon: DashboardCards[5].icon,
        count: rejectedCount
      }
    ]
    
    // Initialize comparison charts
    this.initializeComparisonCharts();
  }
  
  initializeComparisonCharts() {
    const goalsCount = this.performnceCards[0]?.count || 0;
    const indicatorsCount = this.performnceCards[1]?.count || 0;
    const projectsCount = this.performnceCards[2]?.count || 0;
    const approvedCount = this.performnceCards[3]?.count || 0;
    const pendingCount = this.performnceCards[4]?.count || 0;
    const rejectedCount = this.performnceCards[5]?.count || 0;
    
    const goalsLabel = this.dir === 'rtl' ? 'الأهداف' : 'Goals';
    const indicatorsLabel = this.dir === 'rtl' ? 'المؤشرات' : 'Indicators';
    const projectsLabel = this.dir === 'rtl' ? 'المبادرات' : 'Projects';
    const totalProjectsLabel = this.dir === 'rtl' ? 'إجمالي المبادرات' : 'Total Projects';
    const inProgressLabel = this.dir === 'rtl' ? 'قيد التنفيذ' : 'In Progress';
    const approvedLabel = this.dir === 'rtl' ? 'معتمدة' : 'Approved';
    const pendingLabel = this.dir === 'rtl' ? 'قيد التقييم' : 'Pending';
    const rejectedLabel = this.dir === 'rtl' ? 'مرفوضة' : 'Rejected';
    
    // Chart 1: Strategic Hierarchy (Goals, Indicators, Projects)
    this.strategicAlignmentChart = {
      series: [{
        name: goalsLabel,
        data: [goalsCount]
      }, {
        name: indicatorsLabel,
        data: [indicatorsCount]
      }, {
        name: projectsLabel,
        data: [projectsCount]
      }],
      chart: {
        type: 'bar',
        height: 300,
        fontFamily: 'Cairo, sans-serif',
        toolbar: {
          show: false
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 1200,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        }
      },
      colors: ['#C91F3B', '#A71932', '#8B1529'],
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '55%',
          borderRadius: 8,
          dataLabels: {
            position: 'top'
          }
        }
      },
      dataLabels: {
        enabled: true,
        offsetY: -20,
        style: {
          fontSize: '14px',
          fontWeight: 'bold',
          colors: ['#1f2937']
        }
      },
      xaxis: {
        categories: [this.dir === 'rtl' ? 'المستوى الاستراتيجي' : 'Strategic Level'],
        labels: {
          style: {
            fontSize: '12px',
            fontWeight: 600
          }
        }
      },
      yaxis: {
        title: {
          text: this.dir === 'rtl' ? 'العدد' : 'Count',
          style: {
            fontSize: '14px',
            fontWeight: 600
          }
        }
      },
      legend: {
        position: 'top',
        horizontalAlign: 'center',
        fontSize: '14px',
        fontWeight: 600
      }
    };
    
    // Chart 2: Total vs Pending Projects (Donut Chart)
    this.projectsComparisonChart = {
      series: [projectsCount, pendingCount],
      chart: {
        type: 'donut',
        height: 220,
        width: '100%',
        fontFamily: 'Cairo, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 2000,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        }
      },
      colors: ['#C91F3B', '#6b7280'],
      labels: [totalProjectsLabel, pendingLabel],
      legend: {
        show: false
      },
      dataLabels: {
        enabled: true,
        formatter: function(val: number, opts: any) {
          return val.toFixed(1) + '%';
        },
        style: {
          fontSize: '12px',
          fontWeight: 'bold',
          colors: ['#2d3748']
        },
        dropShadow: {
          enabled: false
        },
        background: {
          enabled: false
        }
      },
      plotOptions: {
        pie: {
          donut: {
            size: '62%',
            labels: {
              show: false
            }
          },
          expandOnClick: false,
          dataLabels: {
            offset: 28,
            minAngleToShowLabel: 10
          }
        }
      },
      responsive: [{
        breakpoint: 480,
        options: {
          chart: {
            width: 300
          },
          plotOptions: {
            pie: {
              dataLabels: {
                offset: 20
              }
            }
          }
        }
      }],
      tooltip: {
        enabled: true,
        y: {
          formatter: function(val: number) {
            return val + '';
          }
        }
      },
      stroke: {
        show: true,
        width: 2,
        colors: ['#ffffff']
      }
    };
    
    // Chart 3: Projects Status Distribution (Pie Chart) - Approved, Pending, Rejected
    this.projectsStatusChart = {
      series: [approvedCount, pendingCount, rejectedCount],
      chart: {
        type: 'pie',
        height: 300,
        fontFamily: 'Cairo, sans-serif',
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 1000,
          animateGradually: {
            enabled: true,
            delay: 150
          },
          dynamicAnimation: {
            enabled: true,
            speed: 350
          }
        }
      },
      colors: ['#28a745', '#6b7280', '#dc3545'],
      labels: [approvedLabel, pendingLabel, rejectedLabel],
      legend: {
        position: 'bottom',
        fontSize: '14px',
        fontWeight: 600
      },
      dataLabels: {
        enabled: true,
        style: {
          fontSize: '14px',
          fontWeight: 'bold'
        },
        dropShadow: {
          enabled: false
        }
      },
      plotOptions: {
        pie: {
          expandOnClick: true,
          dataLabels: {
            offset: 0
          }
        }
      }
    };
  }
  isModalVisable(performanceCardsNamesEnum: PerformanceCardsNamesEnum) {
    this.selectedModalType = performanceCardsNamesEnum
    const localeKey = this.dir == 'ltr' ? "enName" : "arName";
    
    // Find the corresponding dashboard card
    const dashboardCard = DashboardCards.find(card => card.id === performanceCardsNamesEnum);
    if (dashboardCard) {
      this.modalHeaderName = dashboardCard[localeKey];
    } else {
      this.modalHeaderName = '';
    }
    
    this.visible = true;
  }
  isProjectModalVisable(performanceCardsNamesEnum: ProjectCardsNamesEnum) {
    this.selectedModalType = performanceCardsNamesEnum;
    switch (performanceCardsNamesEnum) {
      case ProjectCardsNamesEnum.resources:
        this.modalHeaderName = this.projectCardLocales[0][this.dir == 'ltr' ? "enName" : "arName"]
        break;
      case ProjectCardsNamesEnum.milestones:
        this.modalHeaderName = this.projectCardLocales[1][this.dir == 'ltr' ? "enName" : "arName"]
        break;
      case ProjectCardsNamesEnum.risks:
        this.modalHeaderName = this.projectCardLocales[2][this.dir == 'ltr' ? "enName" : "arName"]
        break;
      default:
        this.modalHeaderName = '';
        break;
    }
    this.isProjectVisable = true;
  }
  //hover
  onMouseEnter(hoverIndicatorId: number) {
    this.hoverIndicatorId = hoverIndicatorId;
  }
  onMouseLeave() {
    this.hoverIndicatorId = 0;
  }
  onProjectMouseEnter(hoveredProjectId: number) {
    this.hoveredProjectId = hoveredProjectId;
  }
  onProjectMouseLeave() {
    this.hoveredProjectId = 0;
  }
  strategyOptionsChange() {
    this.strategyService.setStrategyIdfn(this.selectedStrategyId)
    this.socketService.setRefreshNotification(this.selectedStrategyId)
  }

  changeYear() {
    console.log("selectedDepartment", this.selectedDepartment);
    console.log("selectedDepartment id", this.selectedDepartment?.id);
    console.log("headerEntityTitelType", this.headerEntityTitelType);
    if (!this.selectedDepartment || this.selectedDepartment.id == 'all') this.headerEntityTitelType = 'department';

    switch (this.headerEntityTitelType) {
      case 'department':
        if (!this.selectedDepartment || this.selectedDepartment.id == 'all') {
          this.dashboardService.getPerformanceOverview(this.selectedStrategyId as number, this.selectedYear.id)
            .subscribe((response: any) => {
              this.setYears(response["data"]["years"]);
              this.setDepartments(response["data"]["departments"])
              console.log(this.departments);
              this.sections = response['data']['units']
              this.filteredSections = response['data']['units']
              this.mapUnitPerfomanceCards(response)
              this.selectedProjectId = 0;
              this.selectedSection = 0;
            })
          return;
        }
        this.filteredSections = this.selectedDepartment.units;
        this.dashboardService.setDepartmentSub({
          strategyId: this.selectedStrategyId,
          departmentId: this.selectedDepartment.id,
          year: this.selectedYear.id
        })
        this.headerEntityTitelType = "department";
        this.selectedProjectId = 0;
        this.selectedSection = 0;
        break;

      case 'section':
        this.dashboardService.seSectionSub({
          strategyId: this.selectedStrategyId,
          sectionId: this.selectedSectionId,
          year: this.selectedYear.id
        })
        this.headerEntityTitelType = "section";
        this.selectedSection = this.filteredSections.find((x: any) => x.id == this.selectedSectionId)
        this.selectedProjectId = 0;
        this.selectedDepartment = 0;
        break;

      case 'project':
        this.headerEntityTitelType = "project";
        const selectedProject = this.filteredProjects.find((x: any) => x.id = this.selectedProjectId);
        this.selectedProjectName = selectedProject.name;
        this.dashboardService.setProjectSub({
          strategyId: this.selectedStrategyId,
          projectId: this.selectedProjectId,
          year: this.selectedYear.id
        })
        break;
    }
  };

  setYears(resYears: []) {
    this.years = [
      ...resYears.map((year: any) => {
        return {
          name: typeof year == "object" ? year.name : year,
          id: typeof year == "object" ? year.id : year,
        }
      })
    ];
    if (this.years.find((year: any) => year.id == "all")) this.years.shift();
    this.years.unshift(
      {
        name: this.dir == "ltr" ? "All Years" : "كل الأعوام",
        id: "all"
      }
    );
    if (this.selectedYear.id == "all") this.selectedYear = this.years.find((year: any) => year.id == "all") as any;
  };

  setDepartments(resDeps: [] = []) {
    this.departments = [...resDeps]
    if (this.departments.find((department: any) => department.id == "all")) this.departments.shift();
    this.departments.unshift(
      {
        name: this.dir == "ltr" ? "All Organization's Departments" : "كل إدارات المؤسسة",
        id: "all"
      }
    )
    if (!this.selectedDepartment || this.selectedDepartment.id == "all") {
      this.selectedDepartment = this.departments.find((departments: any) => departments.id == "all") as any;
    }
  };

  getWeightColor(weight: number) {
    const weightColors = {
      25: "#cc3300",
      20: "#ff9966",
      15: "#ffcc00",
      10: "#99cc33",
      5: "#339900",
      1: "#28a745"
    }
    if (weight == 1) return weightColors[1]
    if (weight > 1 && weight <= 5) return weightColors[5]
    if (weight > 5 && weight <= 10) return weightColors[10]
    if (weight > 10 && weight <= 15) return weightColors[15]
    if (weight > 15 && weight <= 20) return weightColors[20]
    if (weight > 20 && weight <= 25) return weightColors[25]
    return ''
  }

  setLocale() {
    this.projectCards = structuredClone(this.projectCards.map((card, index) => {
      return {
        ...card,
        name: this.projectCardLocales[index]?.[this.dir == 'ltr' ? "enName" : "arName"] || card.name
      }
    }))

    const localeKey = this.dir == 'ltr' ? "enName" : "arName";
    this.performnceCards = structuredClone(this.performnceCards.map((card) => {
      const dashboardCard = DashboardCards.find(dc => dc.id === card.id);
      return {
        ...card,
        name: dashboardCard ? dashboardCard[localeKey] : card.name
      }
    }))
    console.log("projectCards", this.projectCards);
    
    // Reinitialize charts when language changes
    if (this.performnceCards.length > 0) {
      this.initializeComparisonCharts();
    }
  };
  
  toggleFilters() {
    this.filtersVisible = !this.filtersVisible;
  }
  
  openIndicatorsModal() {
    this.visible = true;
    this.selectedModalType = PerformanceCardsNamesEnum.indicators;
    this.modalHeaderName = this.dir === 'rtl' ? 'المؤشرات' : 'Indicators';
  }
  
  openProjectsModal() {
    this.visible = true;
    this.selectedModalType = PerformanceCardsNamesEnum.projects;
    this.modalHeaderName = this.dir === 'rtl' ? 'المبادرات' : 'Projects';
  }
  
  getProgressPercentage(value: number): number {
    // Get the maximum value from goals, indicators, and projects
    const maxValue = Math.max(
      this.performnceCards[0]?.count || 0,
      this.performnceCards[1]?.count || 0,
      this.performnceCards[2]?.count || 0
    );
    
    // If maxValue is 0, return 0 to avoid division by zero
    if (maxValue === 0) return 0;
    
    // Calculate percentage based on the max value
    return (value / maxValue) * 100;
  }
}
